import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/Index.vue";
import About from "../views/About.vue";
import Catalogue from "../views/Catalogue.vue";
import Product from "../views/Product.vue";
import Cart from "../views/Cart.vue";


Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "index",
        component: Index
    },
    {
        path: "/o-mne",
        name: "about",
        component: About
    },
    {
        path: "/katalog",
        name: "catalogue",
        component: Catalogue
    },
    {
        path: "/produkt/:id",
        props: true,
        name: "product",
        component: Product
    },
    {
        path: "/kosik",
        name: "cart",
        component: Cart
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;
